import { createVNode, ref, render } from 'vue';
import YxPopup from './popup.vue';

const PopupMap = new Map();
const PopupQueue = [];

// 业务层注册弹窗用
export function registPopup(PopupConstructor) {
  if (PopupMap.get(PopupConstructor.name)) {
    throw new Error(`注册了重复的弹窗:${PopupConstructor.name}`);
  }
  PopupMap.set(PopupConstructor.name, PopupConstructor.component);
}

// 方法调用打开相应弹窗.
async function Popup(name, opts = {}) {
  const slots = null;
  const PopupConstructorAsync = PopupMap.get(name);

  if (!PopupConstructorAsync) {
    throw new Error(`找不到相应的popup:${name}`);
  }
  const { default: PopupConstructor } = await PopupConstructorAsync();
  const container = document.createElement('div');
  const lsShow = ref(false);
  const options = {
    ...opts,
    onDestroy() {
      render(null, container);
      container.remove();
    },
  };

  PopupConstructor.provide = {
    lsShow,
  };

  let close;
  const pro = new Promise((resolve, reject) => {
    Object.assign(options, {
      onConfirm(param) {
        close();
        resolve(param);
      },
      onCancel(param) {
        close();
        reject(param);
      },
      onClose() {
        close();
        // eslint-disable-next-line prefer-promise-reject-errors
        reject('close');
      },
    });
  });

  const vm = createVNode(PopupConstructor, options, slots);

  close = () => {
    lsShow.value = false;
    PopupQueue.splice(PopupQueue.indexOf(vm), 1);
  };

  // eslint-disable-next-line no-underscore-dangle
  vm.appContext = this._context;

  const elList = Array.from(document.querySelectorAll('button:focus,input:focus'));
  if (elList.length) {
    elList.forEach((el) => el.blur());
  }

  render(vm, container);
  PopupQueue.push(vm);
  document.body.appendChild(container);

  lsShow.value = true;
  return pro;
}

export default {
  install(application, popups) {
    application.component('yx-popup', YxPopup);
    // eslint-disable-next-line no-param-reassign
    application.config.globalProperties.popup = Popup.bind(application);
    // eslint-disable-next-line no-param-reassign
    application.provide('popup', Popup.bind(application));

    popups.forEach((popup) => registPopup(popup));
  },
};
